var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.transition } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "notification",
        class: {
          "notification--sticky":
            _vm.notificationType === "cart-updated" ||
            _vm.notificationType === "single-message",
          "notification--general": _vm.notificationType === "single-message",
          "notification--inline":
            _vm.notificationType === "callback-message" ||
            _vm.notificationType === "info-message",
          "notification--info":
            _vm.notificationType === "callback-message" ||
            _vm.notificationType === "info-message"
        }
      },
      [
        _vm.notificationType === "cart-updated"
          ? [
              _c("span", { staticClass: "notification__cart-amount" }, [
                _vm._v(_vm._s(_vm.totalCartCount))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "notification__text" }, [
                _c("span", { staticClass: "notification__text__highlight" }, [
                  _vm._v(_vm._s(_vm.productsAdded))
                ]),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.productsAdded > 1
                        ? _vm.$modeoL10n.products_added
                        : _vm.$modeoL10n.product_added
                    ) +
                    " " +
                    _vm._s(
                      _vm.orderType === "offer"
                        ? _vm.$modeoL10n.to_offer
                        : _vm.$modeoL10n.to_cart
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              !_vm.isCart
                ? _c(
                    "a",
                    {
                      staticClass: "notification__link",
                      attrs: { href: _vm.cartUrl }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.orderType === "offer"
                            ? _vm.$modeoL10n.go_to_offer
                            : _vm.$modeoL10n.go_to_cart
                        )
                      )
                    ]
                  )
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.notificationType === "single-message" ||
        _vm.notificationType === "info-message"
          ? [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.message)) }
              })
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.notificationType === "callback-message"
          ? [
              _c("div", { staticClass: "notification__container" }, [
                _vm._v("\n        " + _vm._s(_vm.message) + " "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--buy-small notification__button",
                    on: {
                      click: function($event) {
                        _vm.callback()
                        _vm.close()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.callToAction) + "\n        "
                    )
                  ]
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "notification__close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [
            _c("span", { staticClass: "screen-reader-text" }, [
              _vm._v(_vm._s(_vm.$modeoL10n.close_notification))
            ])
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-393b18e3", { render: render, staticRenderFns: staticRenderFns })
  }
}